module.exports = __webpack_public_path__ + "img/asphalted.3e53aaf7.png";